import type { Plugin } from "vue";

export default {
  install(app) {
    app.config.globalProperties.__ = wp.i18n.__;
  },
} as Plugin;

declare module "vue" {
  interface ComponentCustomProperties {
    __: typeof wp.i18n.__;
  }
}
